import { resolveApiUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";
import { type ResultsHeaterProps } from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage";

interface DataProps {
  code: string;
  unit: string;
  value: number | null;
}

interface Props {
  data?: DataProps[];
  code?: string;
}

export async function getHeaterSelection(data: Props): Promise<ResultsHeaterProps[]> {
  const apiUrl = resolveApiUrl(`/heater-selection-assistant/submit`);

  const response = await fetch(apiUrl, {
    body: JSON.stringify(data),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "POST",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  });
  if (!response.ok) {
    throw new Error("Error fetching data");
  }
  return await response.json();
}
